var render = function render(){var _vm=this,_c=_vm._self._c;return _c('facebook-login',{staticClass:"mb-3 w-full",attrs:{"appId":"435564053656119","fields":'name,email,picture',"version":'v16.0'},on:{"login":_vm.onFacebookLogin,"logout":_vm.onFacebookLogout,"sdk-init":_vm.onSdkInit}},[_c('button',[_vm._v("Facebook 登入")])])
}
var staticRenderFns = []

export { render, staticRenderFns }